import { useMemo } from "react";

import { AdminCaseList, SlideAdminList } from "pwapi";

import { AdminCaseListDetail } from "shared/reducers/admin/adminCasesReducer";

import Spinner from "components/Spinner";

import SlidesTable from "./SlidesTable";

const CaseSlidesTable = ({
  pathCase,
}: {
  pathCase: AdminCaseList | AdminCaseListDetail;
}) => {
  // SlidesTable is built for AdminSlide | SlideAdminList so we have to do some manual type re-mapping
  const slides = useMemo(() => {
    if (!(pathCase as AdminCaseListDetail).detailLoaded) return [];

    return (pathCase as AdminCaseListDetail).slides.map((s): SlideAdminList => {
      const block_obj = pathCase.blocks?.find(
        (block) => block.id === s.block_obj_id
      );
      const specimen = pathCase.specimens?.find(
        (specimen) => specimen.id === block_obj?.specimen_id
      );
      return {
        specimen,
        block_obj,
        lab_orders: (pathCase as AdminCaseListDetail).lab_orders || [],
        case: pathCase,
        ...s,
      };
    });
  }, [pathCase.slides, pathCase.blocks, pathCase.specimens]);

  if ((pathCase as AdminCaseListDetail).detailError)
    return <>Error loading Case details</>;

  if (!(pathCase as AdminCaseListDetail).detailLoaded) return <Spinner />;

  return <SlidesTable slides={slides} slideEditUrl="/admin/cases/slides/" />;
};

export default CaseSlidesTable;
